import { useEffect, useMemo } from 'react'

import { calculatePromoCodes } from '../../../../functions'

export default function usePromoCodes(formData, validatedPromoCodes, initPromoCodeSession) {
  useEffect(() => {
    initPromoCodeSession()
  }, [])

  const { calculateProductPromoCode } = useMemo(
    () => calculatePromoCodes(formData, validatedPromoCodes),
    [formData, validatedPromoCodes]
  )

  return {
    calculateProductPromoCode,
  }
}
